import { useTranslation } from "@/hooks/useTranslation";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { HeartHandshake } from "lucide-react";

export default function PhotoResubmitModalDefault() {
  const t = useTranslation();

  return (
    <DialogContent className="dark text-white">
      <DialogHeader>
        <DialogTitle className="flex flex-row items-center text-left mb-4">
          <HeartHandshake className="h-5 w-5 mr-2" />
          {t.PHOTO_UPLOAD_ACTION_REQUIRED.TITLE}
        </DialogTitle>
        <DialogDescription className="text-left text-md">
          {t.PHOTO_UPLOAD_ACTION_REQUIRED.DESCRIPTION}
        </DialogDescription>
        <ul className="list-disc pl-6 space-y-1 pt-2 text-left text-md text-muted-foreground">
          <li>{t.PHOTO_UPLOAD_ACTION_REQUIRED.NO_FACE}</li>
          <li>{t.PHOTO_UPLOAD_ACTION_REQUIRED.NO_FORBIDDEN}</li>
        </ul>
      </DialogHeader>
    </DialogContent>
  );
}
